import { Button, HStack, IconButton } from "@chakra-ui/react"
import { DarkMode } from "../chakra/ui/color-mode"
import Pathicon from "../pathicon/Pathicon"
import Tooltip from "../tooltip/Tooltip"
import type { RichTextEditorControlBarResolved } from "./types"

export type RichTextEditorControlsProps = {
  mode: "view" | "edit"
  canEdit: boolean
  setMode: (mode: "view" | "edit") => void
  controlBar: RichTextEditorControlBarResolved
}

const RichTextEditorControls = ({
  mode,
  canEdit,
  setMode,
  controlBar: bar
}: RichTextEditorControlsProps) => {
  return (
    <HStack
      justify="flex-end"
      mb="0"
      className={`RichTextEditorControls RichTextEditorControls--${mode}`}
      zIndex={1}
      position="absolute"
      css={
        mode === "view"
          ? {
              top: "-0.5rem",
              right: 0
            }
          : {
              top: "1.5rem",
              right: "1.5rem"
            }
      }
    >
      {mode === "view" && bar.showEditButton && canEdit ? (
        <Tooltip title={bar.editButtonLabel}>
          <IconButton
            // @ts-expect-error: TODO: get typing correct using chakra typegen https://chakra-ui.com/docs/get-started/cli#chakra-typegen
            variant="secondaryGray"
            aria-label={bar.editButtonLabel}
            size="sm"
            onClick={async () => {
              if (bar.onEdit) await bar.onEdit()
              setMode("edit")
            }}
          >
            <Pathicon icon="edit" size="0.9rem" />
          </IconButton>
        </Tooltip>
      ) : null}
      {mode === "edit" && bar.showSaveCancelButtons ? (
        <>
          <DarkMode>
            <Button
              size="sm"
              colorPalette="brand"
              disabled={bar.cancelButtonDisabled}
              onClick={async () => {
                if (bar.onCancel) await bar.onCancel()
                setMode("view")
              }}
            >
              {bar.cancelButtonLabel}
            </Button>
          </DarkMode>
          <Button
            size="sm"
            colorPalette="brand"
            disabled={bar.saveButtonDisabled}
            onClick={async () => {
              if (bar.onSave) await bar.onSave()
              setMode("view")
            }}
          >
            {bar.saveButtonLabel}
          </Button>
        </>
      ) : null}
    </HStack>
  )
}

export default RichTextEditorControls
